
import Storage from 'services/storage';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment'

import templates from 'data/MultiStepMock';

// Persists/Fetches from indexDB storage (refer to storage service)
// This API is for MultiStep Journey Demo.
// The data is being served from a static file 'data/MultiStepMock.js' without back-end implementation.

export default class MultiStepTemplatedExperienceAPI {

  private instancesKey = 'multistep:instances';
  private storage = new Storage();

  // Load mock templates here
  getTemplates(): Promise<any> {
    return Promise.resolve(templates);
  }

  // Return starting template
  getTemplate(id: string): Promise<any> {
    return Promise.resolve(Object.assign({}, templates.find(template => template.id === id)));
  }

  async getInstances(): Promise<any> {
    const instances = await this.storage.getItem(this.instancesKey);
    return Promise.resolve(instances);
  }

  async getInstance(id: any): Promise<any> {
    const instances = await this.storage.getItem(this.instancesKey);
    if (instances) {
      const instance = instances.find((instance: any) => instance.id === id);
      return Promise.resolve(instance);
    } else {
      return Promise.reject();
    }
  }

  // Newly created instances will have Audience Optimization featured turned off, which prevents the user from seeing performance graphs.
  // This can be manually turned on by clicking on the row 10 times. (for Demo)
  async createInstance(instance: any): Promise<any> {
    instance.id = uuidv4().toUpperCase();
    instance.createdAt = moment().format("YYYY-MM-DD HH:mm");
    instance.audienceOptimization = {
      isEnabled: false,
      audienceTarget: undefined
    };
    let instances = await this.storage.getItem(this.instancesKey) || [];
    instances.unshift(instance);
    await this.storage.setItem(this.instancesKey, instances);
    return Promise.resolve(instances);
  }

  async updateInstance(instance: any): Promise<any> {
    let instances = await this.storage.getItem(this.instancesKey);
    instance.updatedAt = moment().format("YYYY-MM-DD HH:mm");
    const idx = instances.findIndex((_instance: any) => _instance.id === instance.id);
    instances[idx] = instance;
    await this.storage.setItem(this.instancesKey, instances);
    return Promise.resolve(instances);
  }

  async deleteInstance(id: string): Promise<any> {
    let instances = await this.storage.getItem(this.instancesKey);
    const index = instances.findIndex((instance: any) => instance.id === id);
    instances.splice(index, 1);
    await this.storage.setItem(this.instancesKey, instances);
    return Promise.resolve(instances);
  }

}
